<template>
        <div class="bg-wrap">
            <div class="kv">
            </div>
             <div class="content-wrap">
                    <span class="title">{{title}}</span>
                    <span class="a">竞答题</span>
<!--                    <label class="b" @click="toAnswer" v-if="questionId!=-1">第{{order}}题，开始竞答</label>-->
<!--                    <label class="b" v-if="questionId==-1">已结束</label>-->

                    <label class="b shadow"  v-if="state==0">第{{order}}题，等待开题</label>
                    <label class="b light" v-if="this.state==1" @click="toAnswer">第{{order}}题，抢题</label>
                    <label class="b shadow" v-if="this.state==2">第{{order}}题，答题中</label>
                    <label class="b shadow"  v-if="questionId==-1">竞答结束</label>

                    <label class="b light" @click="toMyQuestion" v-if="unResolveStation==1">我的题目</label>
                    <span class="c">{{hint}}</span>
             </div>
        </div>
</template>

<script>
    import {valuableQuestion,answerPlayerQuestionStation} from "@/assets/js/api";
    import {compQuestion} from "@/assets/js/api";
    export default {
        // inject: ["reload"], //注入reload方法
        data(){
            return{
                title:"共话新知",
                hint:"（共5道题，答对得2分答错不扣分，答题时间1分钟）",
                playerId:this.$store.state.playerId,
                questionId:1,
                type:2,
                unResolveStation:0,
                order:0,
                state:0
            }
        },
        methods:{
            // toReload(){
            //     this.reload();
            // },
            toMyQuestion(){
                this.$router.push({path:"playerCompAnswer"})
            },
            toAnswer(){
                if(this.questionId==-1){
                    this.$toast("请稍等,等主持人开题");
                    return
                }
                this.toCompQuestion(this.playerId,this.questionId);
            },
            async toCompQuestion(playerId,questionId){
                const res = await compQuestion({playerId,questionId})
                console.log(res)
                if(res.data.success){
                    this.$toast("恭喜您抢到本题，请在倒计时结束前作答")
                    this.$router.push({path:"playerCompAnswer"})
                }else{
                    this.$toast(res.data.message)
                }
            },
            async getValuableCompQuestion(type,playerId){
                const res = await valuableQuestion({type,playerId})
                if(res.data.success){
                    this.questionId = res.data.data.questionId
                    this.order = res.data.data.order
                    this.state = res.data.data.state
                }
            },
            async getMyQuestionStation(playerId,type){
                const res = await answerPlayerQuestionStation({playerId,type})
                if(res.data.success){
                    this.unResolveStation = res.data.data
                }
            },
            initWebSocket: function () {
                console.log("---socket 初始化---")
                this.websock = new WebSocket("ws://server.iumed.com.cn/plus/one/websocket");
                // this.websock = new WebSocket("ws://192.168.31.230:9090/one/websocket");
                this.websock.onopen = this.websocketonopen;
                this.websock.onerror = this.websocketonerror;
                this.websock.onmessage = this.websocketonmessage;
                this.websock.onclose = this.websocketclose;
            },
            websocketonopen: function () {
                console.log("WebSocket连接成功");
            },
            websocketonerror: function (e) {
                console.log("WebSocket连接发生错误"+e.code);
            },
            websocketonmessage: function (e) {
                console.log("----signal coming----",e)
                this.loadData();
            },
            websocketclose: function (e) {
                console.log("connection closed (" + e.code + ")");
            },
            loadData() {
                /**
                 * 获取可抢答抢答题目
                 */
                this.getValuableCompQuestion(this.type,this.playerId)
                /**
                 * 我的题目状态
                 */
                this.getMyQuestionStation(this.playerId,this.type)
            }
        },
        mounted(){
            this.loadData();
        },
        created(){
            this.initWebSocket() ;
        }

    }
</script>

<style scoped lang="scss">
    .bg-wrap{
        width: 100%;
        /*max-width: 375px;*/
        height: 100vh;
        background: #FFF url("../../assets/img/answer_bg.png") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
    }
    .kv{
        width: 100%;
        height: 250px;
        background: #FFF url("../../assets/img/answer_kv.png") no-repeat;
        background-size: 100% 100%;
        margin: 0 auto;
        position: relative;
    }
    .content-wrap{
        display: flex;
        flex-flow: column;
        align-items: center;
    }
    .content-wrap .title{
        color: #FFF;
        font-size: 38px;
        font-weight: bold;
        font-style: italic;
        letter-spacing: 3px;
    }

    .a{
        color: #FFF;
        font-size: 25px;
        margin-top: 20px;
        opacity: 0.8;
    }
    .b{
        color: #FFF;
        margin-top: 30px;
        font-size: 14px;
        width: 85%;
        height: 32px;
        line-height: 32px;
        border-radius: 15px;
        display: block;

    }
    .c{
        margin-top: 10px;
        color: #FFF;
        font-size: 15px;
        opacity: 0.8;
    }

    .shadow{
        background: #999;
    }

    .light{
        background: #036eb7;
    }


</style>